/** @jsx jsx */
import { Text, Flex, Divider, jsx } from 'theme-ui'
import { number, string } from 'prop-types'
import { ChevronDown } from '../../../icons'
import { useCalendarArticle } from '../../../hooks/useCalendarArticle'

const CalendarArticleHeader = ({ title, index, id }) => {
  const { isOpen, toggleExpandable } = useCalendarArticle()
  return (
    <Flex
      sx={{
        display: 'flex',
        padding: '15px 0',
        gap: '10px',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'background',
        cursor: 'pointer',
      }}
      data-automation-id={`chevron-open-item-${index}`}
      onClick={() => toggleExpandable(id)}
    >
      <ChevronDown
        color="sky"
        sx={{
          transform: isOpen(id) ? 'rotate(0)' : 'rotate(-90deg)',
          transition: '.5s',
        }}
      />
      <Text
        sx={{
          fontSize: '1.5rem',
          color: 'black',
        }}
      >
        {title}
      </Text>
      <Divider
        sx={{
          flex: 1,
          marginLeft: '5px',
          color: 'black',
        }}
      />
    </Flex>
  )
}

CalendarArticleHeader.propTypes = {
  title: string,
  id: string,
  index: number,
}

export default CalendarArticleHeader
